export default "__VITE_ASSET__BlLmtzOm__"